import React from "react";
import { Link } from "react-router-dom";
import NaytaKoriinNappi from "./NaytaKoriinNappi";

const NaytaKortti = (props) => {
  const { tila, asetatila, tuoteId } = props;

  const tuote = tila.kortit.filter((t) => t.Ttunnus === tuoteId)[0];
  const end = tila.frisbee ? "webp" : "jpg";
  const kuva =
    "/frisbeeapuri/" +
    tuote.Kuvat.Kuva +
    (tuote.Kuvat.Kuva === "liikemerkki" ? "_168.png" : "_300." + end);

  return (
    <div>
      <Link to={"/tuote/" + tuoteId}>
        <label id={tuoteId} className="linkki">
          <img src={kuva} alt="Kuva" className="kuva" />
          <br />
          {tuote.Tuote}
          <br />
          <div className="padbot">{tuote.Hinta} €</div>
        </label>
        <NaytaKoriinNappi asetatila={asetatila} tuoteId={tuoteId} />
      </Link>
    </div>
  );
};
export default NaytaKortti;
